import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../../services/authentication/authentication.service';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {

  result: any;
  error = ''
  success = ''

  constructor(private http: HttpClient, private authenticationService: AuthenticationService, private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit() {

    const currentUser = this.authenticationService.currentUserValue;

    this.route
      .params
      .subscribe(v => {
        //console.log(v);
        switch (v.code) {
          case '0':
            this.error = 'پرداخت توسط کاربر لغو شده است'
            break;
          case '1':
            this.error = 'اطلاعات ارسال شده ناقص است'
            break;
          case '2':
            this.error = 'IP یا مرچنت پذیرنده معتبر نیست'
            break;
          case '3':
            this.error = 'با توجه به محدودیت های شاپرک امکان پرداخت با رقم درخواست شده میسر نیست'
            break;
          case '4':
            this.error = 'سطح تایید پذیرنده پایین تر از سطح نقره ای است'
            break;
          case '8':
            this.error = 'کد تخفیف وارد شده در حال استفاده می باشد'
            break;
          case '9':
            this.error = 'کد تخفیف وارد شده استفاده شده است'
            break;
             case '10':
            this.error = 'کد تخفیف منقضی شده است'
            break;
          case '11':
            this.error = 'درخواست مورد نظر یافت نشد'
            break;
          case '12':
            this.error = 'امکان ویرایش درخواست میسر نمی باشد'
            break;
          case '21':
            this.error = 'سطح تایید پذیرنده پایین تر از سطح نقره ای است'
            break;
          case '22':
            this.error = 'تراکنش ناموفق می باشد'
            break;
          case '33':
            this.error = 'رقم تراکنش با رقم پرداخت شده مطابقت ندارد'
            break;
         case '34':
            this.error = 'سقف تقسيم تراكنش از لحاظ تعداد يا رقم عبور نموده است'
            break;
         case '40':
            this.error = 'اجازه دسترسي به متد مربوطه وجود ندارد'
            break;
          case '41':
            this.error = 'اطلاعات ارسال شده مربوط به AdditionalData غيرمعتبر ميباشد'
            break;
          case '42':
            this.error = 'مدت زمان معتبر طول عمر شناسه پرداخت بايد بين 30 دقيه تا 45 روز مي باشدد'
            break;
          case '54':
            this.error = 'درخواست مورد نظر آرشيو شده است'
            break;
           case '100':
            this.success = 'عمليات با موفقيت انجام گرديده است'
            break;
          case '101':
            this.success = 'عمليات پرداخت موفق بوده و قبلا PaymentVerification تراكنش انجام شده است'
            break;

        }

      });

  }

}
